import { render, staticRenderFns } from "./sticky-container.vue?vue&type=template&id=beb5cd02&scoped=true&lang=html"
import script from "./sticky-container.vue?vue&type=script&lang=js"
export * from "./sticky-container.vue?vue&type=script&lang=js"
import style0 from "./sticky-container.vue?vue&type=style&index=0&id=beb5cd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb5cd02",
  null
  
)

export default component.exports